import Checkbox from './checkbox'
import Group from './group'

Checkbox.Group = Group

export default Checkbox